export const isValidString = (value: string | undefined): boolean => {
  return (
    Boolean(value && value.trim()) &&
    value !== "undefined" &&
    value !== "null" &&
    value !== ""
  );
};
